import { render, staticRenderFns } from "./shipment-claim.vue?vue&type=template&id=7495464c&scoped=true&"
import script from "./shipment-claim.vue?vue&type=script&lang=js&"
export * from "./shipment-claim.vue?vue&type=script&lang=js&"
import style0 from "./shipment-claim.vue?vue&type=style&index=0&id=7495464c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7495464c",
  null
  
)

export default component.exports